import { render } from "./buhuo.vue?vue&type=template&id=8d4a650a&scoped=true"
import script from "./buhuo.vue?vue&type=script&lang=js"
export * from "./buhuo.vue?vue&type=script&lang=js"

import "./buhuo.vue?vue&type=style&index=0&id=8d4a650a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4a650a"]])

export default __exports__